module.exports = __webpack_public_path__ + "static/media/radrouten.5c3cb4cf.jpg";